<template>
    <v-dialog v-model="isActive" fullscreen scrollable transition="slide-x-reverse-transition"
        @keydown.esc="cerrarDialogo">
        <v-card class="rounded-0">
            <!-- v-toolbar y no v-app-bar: el app-bar esta pensado para la barra
                 superior de la aplicacion (se registra en el layout de v-app,
                 tiene scroll behavior y estado booted) y adentro de un dialogo
                 solo aporta 64px de alto fijo. `dense` lo deja en 48. -->
            <v-toolbar flat dense height="48" class="rounded-0 barra-dialogo" color="white">
                <v-tooltip bottom>
                    <template v-slot:activator="{ on, attrs }">
                        <v-btn v-bind="attrs" v-on="on" icon @click="cerrarDialogo">
                            <v-icon>mdi-chevron-left</v-icon>
                        </v-btn>
                    </template>
                    <span>Volver</span>
                </v-tooltip>
                <v-toolbar-title class="text-body-1 font-weight-bold primary--text">
                    Notificaciones
                </v-toolbar-title>
            </v-toolbar>
            <!-- pa-0 mata el padding propio del v-card-text dentro de un dialogo
                 (Vuetify le pone `0 24px 20px`), asi el contenido arranca pegado
                 al app-bar y no flotando mas abajo. -->
            <v-card-text class="pa-0">
                <NotificacionCard :aviso="aviso" @irARuta="irARuta" />
            </v-card-text>
        </v-card>
    </v-dialog>
</template>

<script>
import NotificacionCard from '@/components/cards/NotificacionCard.vue'

/**
 * Dialogo fullscreen para el detalle de una notificacion.
 *
 * Solo se usa en pantallas menores a 960px (breakpoint md de Vuetify). De ahi
 * para arriba la vista de Notificaciones muestra el detalle embebida, sin
 * dialogo: ver Notificaciones.vue.
 */
export default {
    name: 'DialogoNotificacion',

    components: {
        NotificacionCard,
    },

    data() {
        return {
            isActive: false,
            callback: null,
            // Una sola instancia del dialogo sirve a todo el listado: al abrirlo
            // se guarda aca la notificacion elegida.
            aviso: {},
        }
    },

    methods: {
        abrirDialogo(aviso) {
            this.aviso = aviso || {}
            this.isActive = true
            return new Promise(resolve => {
                this.callback = resolve
            })
        },

        cerrarDialogo() {
            if (this.callback) {
                this.callback(true)
                this.callback = null
            }
            this.isActive = false
        },

        // El dialogo es fullscreen: se cierra antes de navegar para no tapar la vista destino.
        irARuta(aviso) {
            this.cerrarDialogo()
            this.$emit('irARuta', aviso)
        },
    },
}
</script>

<style scoped>
/* El v-card del dialogo scrollable es un flex column. Vuetify le fija el flex
   al v-card__title, al v-card__actions y al v-card__text, pero NO a un toolbar
   puesto como hijo directo: nunca contemplo ese caso. Sin esto la barra se
   estira y se come el espacio de arriba.
   `0 0 auto` = no crece, no se achica, mide lo que dice su altura. */
.barra-dialogo {
    flex: 0 0 auto;
}
</style>
